import React, { useEffect, useState, useContext } from 'react';
import Axios from 'axios';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { API_HOST } from '../../consts';
import { withRouter } from 'react-router-dom';
import SerialLineChart from '../relatorio/SerialLineChart';
import TableGeneralStudentReport from '../relatorio/TableGeneralStudentReport';
import HeaderRelatorioTurma from '../../components/HeaderRelatorioTurma';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import { Grid } from '@material-ui/core';
import { ThemeContext } from '../../contexts/ThemeContext';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';

const GeneralStudentReport = ({ match }) => {
  const { filtrosRelatorios } = useContext(FilterRelatorioContext)
  const [habilidadeData, setHabilidadeData] = useState([]);
  const [competenciaData, setCompetenciaData] = useState([]);
  const [escala, setEscala] = useState({})

  const [dadosDisciplinas, setDadosDisciplinas] = useState([]);
  const [dadosAreaConhecimento, setDadosAreaConhecimento] = useState([]);
  const host = window.location.host;

  const theme = useContext(ThemeContext);

  const Accordion = withStyles({
    root: {
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&:before': {
        display: 'none'
      },
      '&$expanded': {
        marginTop: '10px',
        marginBottom: '10px',
        margin: 'auto'
      }
    },
    expanded: {}
  })(MuiAccordion);

  const AccordionSummary = withStyles({
    root: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.primary,
      border: 'none',
      borderRadius: '16px',
      height: '42px',
      boxShadow: '0px 0px 4.94866px rgba(0, 0, 0, 0.25)',
      marginBottom: '10px',
      '&$expanded': {
        minHeight: 56
      }
    },
    content: {
      '&$expanded': {
        margin: '12px 0'
      }
    },
    expanded: {}
  })(MuiAccordionSummary);

  const AccordionDetails = withStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: '#FFFFFF',
      padding: theme.spacing(2),
      border: '1px solid #F7F7F7',
      borderRadius: '8px'
    }
  }))(MuiAccordionDetails);

  const fetchHabilidade = () => {
    const params = {
      tipo: 'turma-habilidade',
      etapa: filtrosRelatorios.nrEtapa,
      turma: filtrosRelatorios.cd_turma,
      ano: filtrosRelatorios.periodoAno,
      escola: filtrosRelatorios.currentEscola
    };

    Axios.get(
      `${API_HOST}/avalia/estudante_desempenho/get_complex_data_table_turma`,
      { params }
    )
      .then((res) => {
        setHabilidadeData(res.data.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchCompetencia = () => {
    const params = {
      tipo: 'turma-competencia',
      etapa: filtrosRelatorios.nrEtapa,
      turma: filtrosRelatorios.cd_turma,
      ano: filtrosRelatorios.periodoAno,
      escola: filtrosRelatorios.currentEscola
    };
    Axios.get(
      `${API_HOST}/avalia/estudante_desempenho/get_complex_data_table_turma`,
      { params }
    )
      .then((res) => {
        setCompetenciaData(res.data.data);
        setEscala({ 'competencia': res.data.data.escala })
      })
      .catch((err) => console.error(err));
  };

  const columnsHabilidade = [
    { id: 'habilidade', label: 'Habilidade', minWidth: 170, align: 'center' },
    {
      id: 'area_conhecimento',
      label: 'Area Conhecimento',
      minWidth: 170,
      align: 'center'
    },
    { id: 'itens', label: 'Itens', align: 'center' },
    { id: 'qtd_total', label: 'Respostas Recebidas', align: 'center' },
    { id: 'qtd', label: 'Acertos', align: 'center' },
    {
      id: 'porc_acertos',
      label: 'Porc. Acertos',
      align: 'center'
    },
    { id: 'status', label: 'Status', align: 'center' }
  ];

  const columnsCompetencia = [
    { id: 'competencia', label: 'Competência', minWidth: 170, align: 'center' },
    {
      id: 'area_conhecimento',
      label: 'Area Conhecimento',
      minWidth: 170,
      align: 'center'
    },
    { id: 'qtd_total', label: 'Quantidade', align: 'center' },
    { id: 'qtd', label: 'Acertos', align: 'center' },
    {
      id: 'porc_acertos',
      label: 'Porc. Acertos',

      align: 'center'
    },
    { id: 'status', label: 'Status', align: 'center' }
  ];

  const fetchDataDisciplinas = () => {
    const params = {
      turma: filtrosRelatorios.cd_turma,
      etapa: filtrosRelatorios.nrEtapa,
      escola: filtrosRelatorios.currentEscola,
      tipo: 'turma-disciplina'
    };
    Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, {
      params
    }).then((response) => {
      setDadosDisciplinas(response.data.data.data);
    });
  };

  const fetchDataAreaConhecimento = () => {
    const params = {
      turma: filtrosRelatorios.cd_turma,
      etapa: filtrosRelatorios.nrEtapa,
      escola: filtrosRelatorios.currentEscola,
      tipo: 'turma-area-conhecimento'
    };
    Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, {
      params
    }).then((response) => {
      setDadosAreaConhecimento(response.data.data.data);
      setEscala({ 'area_conhecimento': response.data.data.escala })
    });
  };

  useEffect(() => {
    fetchHabilidade();
    fetchCompetencia();
    fetchDataAreaConhecimento();
    fetchDataDisciplinas();
  }, []);

  return (
    <>
      <>
        <div
          className="card-header"
          style={{
            marginBottom: '-0.7rem',
            backgroundColor: '#f7f7f7',
            borderRadius: '10px'
          }}
        >
          <span
            style={{
              fontSize: '14px',
              color: '#292929',
              fontWeight: 500,
              fontFamily: 'Quicksand'
            }}
          >
            Visão Geral da Turma
          </span>
          <hr
            style={{
              background: '#bebebe',
              width: '100%',
              height: '1px',
              borderRadius: '1px'
            }}
          />
        </div>
        <div
          className="input-type-style"
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginLeft: '4rem',
            flexDirection: 'column'
          }}
        >
          <Accordion
            defaultExpanded
            style={{ marginTop: '1rem', width: '100%' }}
          >
            <AccordionSummary
              expandIcon={
                <ArrowDropDownIcon
                  style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                />
              }
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <label
                  style={{
                    color: '#FFFFFF',
                    fontFamily: 'Quicksand',
                    fontWeight: '700',
                    fontSize: '19px',
                    marginBottom: '2px',
                    marginRight: '5px'
                  }}
                >
                  Relatórios por disciplinas
                </label>
                <HelpOutlinedIcon
                  style={{
                    fontSize: '19px',
                    color: theme.secondary
                  }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Grid item container xs={12} md={12}>
                <Grid item xs={12}>
                  {dadosDisciplinas &&
                    dadosDisciplinas.map((element) =>
                      element['titulo'] && (
                        <SerialLineChart
                          style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                          titulo={element['titulo']}
                          dados={element['inform']}
                          tituloCompleto={`Gráfico de desempenho em ${element['titulo']}`}
                        />
                      )
                    )}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            defaultExpanded
            style={{ marginTop: '1rem', width: '100%' }}
          >
            <AccordionSummary
              expandIcon={
                <ArrowDropDownIcon
                  style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                />
              }
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <label
                  style={{
                    color: '#FFFFFF',
                    fontFamily: 'Quicksand',
                    fontWeight: '700',
                    fontSize: '19px',
                    marginBottom: '2px',
                    marginRight: '5px'
                  }}
                >
                  Relatórios por área de conhecimento
                </label>
                <HelpOutlinedIcon
                  style={{ fontSize: '19px', color: theme.secondary }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Grid item container xs={12} md={12}>
                <Grid item xs={12}>
                  {dadosAreaConhecimento &&
                    dadosAreaConhecimento.map((element) =>
                      element['titulo'] && (
                        <SerialLineChart
                          titulo={element['titulo']}
                          escala={escala['area_conhecimento']}
                          dados={element['inform']}
                          tituloCompleto={`Gráfico de desempenho em ${element['titulo']}`}
                        />
                      )
                    )}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          {/* <ComplexLineChart tituloCompleto={'Média de desempenho da turma por prova por disciplina'} tipo={'turma-disciplina'} turma={cd_turma} escola={cd_escola} etapa={cd_etapa} titulo={'Disciplinas'} />
                    <ComplexLineChart tituloCompleto={'Média de desempenho da turma por prova por área do conhecimento'}  tipo={'turma-area-conhecimento'} turma={cd_turma} escola={cd_escola} etapa={cd_etapa} titulo={'Áreas do conhecimento'} /> */}

          <Accordion
            defaultExpanded
            style={{ marginTop: '1rem', width: '100%' }}
          >
            <AccordionSummary
              expandIcon={
                <ArrowDropDownIcon
                  style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
                />
              }
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <label
                  style={{
                    color: '#FFFFFF',
                    fontFamily: 'Quicksand',
                    fontWeight: '700',
                    fontSize: '19px',
                    marginBottom: '2px',
                    marginRight: '5px'
                  }}
                >
                  Relatórios por Habilidades e Competências
                </label>
                <HelpOutlinedIcon
                  style={{ fontSize: '19px', color: theme.secondary }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Grid item container xs={12} md={12}>
                <Grid item xs={12}>
                  <h1> Habilidade </h1>
                  <TableGeneralStudentReport
                    columns={columnsHabilidade}
                    rows={habilidadeData}
                    pagination={true}
                  />
                    <h1> Competência </h1>
                    <TableGeneralStudentReport
                      columns={columnsCompetencia}
                      rows={competenciaData}
                      pagination={true}
                    />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </div>
      </>
    </>
  );
};

export default withRouter(GeneralStudentReport);
